import api from '@/utils/api'

export default {
    getSponsors(page = 1, size = 0) {
        const range = `?page=${page}&per_page=${size}`
        return api.get('sponsor/all' + range)
    }
}
